'use client';

import { useRouter } from 'next/navigation';

import EarnMissionListItem from '@/app/(football)/[team]/_components/common/EarnMissionListItem';
import MissionListItem from '@/app/(football)/[team]/_components/common/MissionListItem';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import SectionHeader from '@/app/(football)/[team]/main/_components/Section/SectionHeader';

interface MissionData {
  methodIdx: number;
  methodCode: string;
  title: string;
  image: string;
  point: number;
  link?: string;
  applyCount: number;
  offlineYn: 'Y' | 'N';
}

interface AvailableMissionSectionProps {
  missionList?: MissionData[];
}

export default function AvailableMissionSection({ missionList = [] }: AvailableMissionSectionProps) {
  const router = useRouter();
  const { teamSlug } = useTeamConfig();

  const routeToMiniGame = () => {
    router.push(`/${teamSlug}/mini-game`);
  };

  return (
    <section className="flex w-full flex-col gap-5 px-5 pb-16">
      <SectionHeader linkUrl={`/${teamSlug}/point-lounge/earn`} color="--color-g-00">지금 참여 가능한 미션</SectionHeader>

      <ul className="flex w-full flex-col gap-3">
        {missionList.map((item) => (
          <EarnMissionListItem
            key={item.methodIdx}
            methodIdx={item.methodIdx}
            methodCode={item.methodCode}
            title={item.title}
            image={item.image}
            point={item.point}
            link={item.link}
            offlineYn={item.offlineYn}
            hasCompleted={item.applyCount > 0}
          />
        ))}
        {/* Mini Game Shortcut */}
        <MissionListItem
          title="미니게임 하러가기"
          image={`https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_clay_minigame.webp`}
          buttonText="게임하기"
          onClick={routeToMiniGame}
        />
      </ul>
    </section>
  );
}
